(function () {
  'use strict';

  var cache = new Map();

  function normalize(value) {
    return (value || '').toString().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/(\d)([a-z])/g, '$1 $2').replace(/([a-z])(\d)/g, '$1 $2').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }

  function rankProducts(items, query) {
    var phrase = normalize(query);
    var words = phrase.split(/\s+/).filter(Boolean);
    return items.map(function (item, index) {
      var title = normalize(item.getAttribute('data-title'));
      var vendor = normalize(item.getAttribute('data-vendor'));
      var tokens = (title + ' ' + vendor).split(/\s+/);
      var covered = words.filter(function (word) {
        return tokens.some(function (token) { return token === word || (word.length >= 2 && token.indexOf(word) === 0); });
      }).length;
      var score = words.length ? covered / words.length * 100 : 0;
      if (title.indexOf(phrase) !== -1) score += 40;
      if (title.indexOf(phrase) === 0) score += 20;
      return { item: item, index: index, score: score };
    }).sort(function (a, b) { return b.score - a.score || a.index - b.index; }).map(function (entry) { return entry.item; });
  }

  function initProductSearch(root) {
    if (root.getAttribute('data-tbs-search-ready')) return;
    var input = root.querySelector('input[type="search"]');
    var menu = root.querySelector('.tbs-product-suggestions');
    var form = root.querySelector('form');
    var status = root.querySelector('[data-tbs-search-status]');
    var endpoint = root.getAttribute('data-predictive-url');
    if (!input || !menu || !form || !endpoint) return;
    root.setAttribute('data-tbs-search-ready', 'true');

    var brandSource = Array.from(root.querySelectorAll('[data-header-brand]'));
    var controller = null;
    var timer = null;
    var generation = 0;
    var active = -1;

    function message(key) { return root.getAttribute('data-text-' + key) || ''; }
    function announce(value) { if (status) status.textContent = value; }
    function cancel() {
      window.clearTimeout(timer);
      if (controller) controller.abort();
      controller = null;
      generation += 1;
    }
    function close() {
      menu.hidden = true;
      menu.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-busy', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
      announce('');
    }
    function open() {
      menu.hidden = false;
      menu.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      active = -1;
      input.removeAttribute('aria-activedescendant');
    }
    function makeGroup(label) {
      var group = document.createElement('div');
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', label);
      var heading = document.createElement('div');
      heading.className = 'tbs-suggest-group__label';
      heading.setAttribute('role', 'presentation');
      heading.textContent = label;
      group.appendChild(heading);
      return group;
    }
    function getBrandMatches(query) {
      var phrase = normalize(query);
      return brandSource.filter(function (brand) {
        var name = normalize(brand.getAttribute('data-header-brand'));
        return name.indexOf(phrase) !== -1;
      }).slice(0, 3);
    }
    function addBrands(query) {
      var matches = getBrandMatches(query);
      if (!matches.length) return;
      var group = makeGroup(message('brands'));
      matches.forEach(function (source) {
        var link = document.createElement('a');
        link.className = 'tbs-header-brand-suggestion';
        link.href = source.href;
        link.setAttribute('data-tbs-search-choice', '');
        var name = document.createElement('strong');
        name.textContent = source.textContent;
        var label = document.createElement('span');
        label.textContent = message('brand');
        link.appendChild(name);
        link.appendChild(label);
        group.appendChild(link);
      });
      menu.appendChild(group);
    }
    function allResults(query) {
      var link = document.createElement('a');
      var target = new URL(form.action, window.location.href);
      target.searchParams.set('type', 'product');
      target.searchParams.set('q', query);
      target.searchParams.set('options[prefix]', 'last');
      target.searchParams.set('sort_by', 'relevance');
      link.href = target.toString();
      link.className = 'tbs-predictive-all';
      link.setAttribute('data-tbs-search-choice', '');
      link.textContent = message('all-results').replace('__QUERY__', query);
      menu.appendChild(link);
    }
    function choices() { return Array.from(menu.querySelectorAll('[data-tbs-search-choice]')); }
    function prepareChoices() {
      choices().forEach(function (item, index) {
        item.id = menu.id + '-option-' + index;
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.setAttribute('tabindex', '-1');
      });
    }
    function render(query, html, failed) {
      menu.replaceChildren();
      addBrands(query);
      var parsed = html ? new DOMParser().parseFromString(html, 'text/html') : null;
      var items = parsed ? Array.from(parsed.querySelectorAll('[data-tbs-predictive-item]')) : [];
      var ordered = rankProducts(items, query).slice(0, 10);
      if (ordered.length) {
        var group = makeGroup(message('products'));
        ordered.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('data-tbs-search-choice', '');
          group.appendChild(clone);
        });
        menu.appendChild(group);
      } else {
        var empty = document.createElement('div');
        empty.className = 'tbs-predictive-empty';
        empty.setAttribute('role', 'presentation');
        empty.textContent = message(failed ? 'unavailable' : 'empty');
        menu.appendChild(empty);
      }
      allResults(query);
      prepareChoices();
      input.setAttribute('aria-busy', 'false');
      open();
      menu.scrollTop = 0;
      announce(ordered.length ? message('count').replace('__COUNT__', String(ordered.length)) : message(failed ? 'unavailable' : 'empty'));
    }
    function load(query, ticket) {
      if (ticket !== generation) return;
      var target = new URL(endpoint, window.location.href);
      target.searchParams.set('q', query);
      target.searchParams.set('resources[type]', 'product');
      target.searchParams.set('resources[limit]', '10');
      target.searchParams.set('resources[options][unavailable_products]', 'last');
      target.searchParams.set('section_id', 'tbs-predictive-search');
      var key = target.toString();
      if (cache.has(key)) { render(query, cache.get(key), false); return; }
      var currentController = new AbortController();
      controller = currentController;
      var timeout = window.setTimeout(function () { currentController.abort(); }, 10000);
      input.setAttribute('aria-busy', 'true');
      announce(message('loading'));
      fetch(key, { signal: currentController.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Search unavailable');
          return response.text();
        })
        .then(function (html) {
          if (ticket !== generation) return;
          if (!html.includes('tbs-predictive-results')) throw new Error('Search unavailable');
          if (cache.size >= 30) cache.delete(cache.keys().next().value);
          cache.set(key, html);
          render(query, html, false);
        })
        .catch(function () { if (ticket === generation) render(query, '', true); })
        .finally(function () { window.clearTimeout(timeout); });
    }
    function queue() {
      cancel();
      close();
      var query = input.value.trim();
      if (query.length < 2) return;
      var ticket = generation;
      timer = window.setTimeout(function () { load(query, ticket); }, 180);
    }

    input.addEventListener('input', queue);
    input.addEventListener('focus', queue);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { cancel(); close(); return; }
      if (event.key === 'Tab') { cancel(); close(); return; }
      var items = choices();
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'ArrowDown' && items.length) {
        event.preventDefault();
        active = (active + 1) % items.length;
      } else if (event.key === 'ArrowUp' && items.length) {
        event.preventDefault();
        active = (active - 1 + items.length) % items.length;
      } else if (event.key === 'Enter' && active >= 0 && items[active]) {
        event.preventDefault();
        window.location.assign(items[active].href);
        return;
      } else return;
      items.forEach(function (item, index) {
        item.classList.toggle('is-active', index === active);
        item.setAttribute('aria-selected', index === active ? 'true' : 'false');
      });
      input.setAttribute('aria-activedescendant', items[active].id);
      items[active].scrollIntoView({ block: 'nearest' });
    });
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) { cancel(); close(); }
    });
    root.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !root.contains(event.relatedTarget)) { cancel(); close(); }
    });
  }

  function init(scope) {
    if (scope.matches && scope.matches('[data-tbs-product-search]')) initProductSearch(scope);
    scope.querySelectorAll('[data-tbs-product-search]').forEach(initProductSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
